/**
 * Assistant Trigger Button
 *
 * Icon button for the TopNavigation that opens/closes the global assistant panel.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useGlobalAssistant } from '@/contexts/GlobalAssistantContext';

export function AssistantTrigger() {
  const { isOpen, togglePanel } = useGlobalAssistant();

  return (
    <Button
      variant={isOpen ? 'default' : 'ghost'}
      size="icon"
      onClick={togglePanel}
      className={cn(
        'relative',
        isOpen && 'bg-purple-600 hover:bg-purple-700 text-white'
      )}
      title={isOpen ? 'Close assistant' : 'Open assistant'}
    >
      <Sparkles className="h-4 w-4" />
    </Button>
  );
}

export default AssistantTrigger;
